import { useModalMultiple, withModalConditionalRender } from '@billy/design-system'
import { useEffect } from 'react'

import { ModalId } from '../../../../enums/modalId'
import { useBankIntegration } from '../../contexts/bankIntegrationContext'
import { BankAccountOrphanedModal as BankAccountOrphaned } from './elements/BankAccountOrphanedModal/BankAccountOrphanedModal'
import { BankConnectionFailedModal as BankConnectionFailed } from './elements/BankConnectionFailedModal/BankConnectionFailedModal'
import { ConnectionExpiredModal } from './elements/ConnectionExpiredModal/ConnectionExpiredModal'

const BankAccountOrphanedModal = withModalConditionalRender(BankAccountOrphaned)
const BankConnectionFailedModal = withModalConditionalRender(BankConnectionFailed)
const BankConnectionExpiredModal = withModalConditionalRender(ConnectionExpiredModal)

export const BankConnectionStatusActions = () => {
  const { open: openModal } = useModalMultiple([ModalId.BankAccountOrphanedModal, ModalId.BankConnectionFailedModal])

  const { connectedBankAccountId, isOrphaned, hasBankConnectionError } = useBankIntegration()

  // Open modals related to bank connection errors
  useEffect(() => {
    if (isOrphaned) {
      openModal(ModalId.BankAccountOrphanedModal)
    } else if (hasBankConnectionError) {
      openModal(ModalId.BankConnectionFailedModal)
    }
  }, [hasBankConnectionError, isOrphaned, openModal])

  return (
    <>
      <BankConnectionFailedModal id={ModalId.BankConnectionFailedModal} />
      <BankAccountOrphanedModal id={ModalId.BankAccountOrphanedModal} />
      <BankConnectionExpiredModal
        connectedBankAccountId={connectedBankAccountId}
        id={ModalId.BankConnectionExpiredModal}
      />
    </>
  )
}
